import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LucideIconComponent } from '../../lucide-icon/lucide-icon.component';
import { NavigationService } from '../../../../core/services/navigation.service';

@Component({
  selector: 'app-tablet-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, LucideIconComponent],
  templateUrl: './tablet-sidebar.component.html',
  styleUrl: './tablet-sidebar.component.css',
})
export class TabletSidebarComponent {
  navService = inject(NavigationService);
}
